import { SubmissionType } from './submission';

export type Seasonal = {
  start: { day: number, month: number },
  end: { day: number, month: number },
}

export type TemplateCategoryItem = {
  name: string;
  id: string;
  critical?: boolean;
  seasonal?: Seasonal;
}

export enum CategoryType {
  Trailer = 'trailer',
  Vehicle = 'vehicle',
}

export type TemplateCategory = {
  name: string;
  id: string;
  items: TemplateCategoryItem[];
  categoryType: CategoryType;
}

export type DvirTranslations = {
  [language: string]: Record<string, string>;
};

interface Template {
  name: string;
  id: string;
  categories: TemplateCategory[];
  templateType?: SubmissionType;
  templateTypes?: SubmissionType[];
  /** timeToLive - specifies time to live for dvir form (units - days) */
  timeToLive: number;
  translations: DvirTranslations;
}

export default Template;

export interface DvirTemplate extends Template {
  trailerTemplate?: Template;
}
